module.exports = __webpack_public_path__ + "static/media/carrot.5fc87ef6.svg";